import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { parse, isValid, getYear, getMonth, getDate, isSameDay } from 'date-fns';


const noop = (_) => { };
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DropDownDatePickerComponent),
  multi: true
};

@Component({
    selector: 'drop-down-date-picker',
    templateUrl: './drop-down-date-picker.component.html',
    styleUrls: ['./drop-down-date-picker.component.css'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class DropDownDatePickerComponent implements OnInit, OnChanges, ControlValueAccessor {
  public SelectedDate : string = 'abcd';
  @Input() set birthYearsOnly(birthYearsOnlySetting: boolean) {
    this.useBirthYearRange = birthYearsOnlySetting;
  }
  @Input() disabled = false;
  @Input() errors: { [key: string]: string[] } = {};
  @Output() errorsChanged = new EventEmitter<{ [key: string]: string[] }>();

  ngOnInit() {
    this.initRanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes) { return; }

    const errorsProp = 'errors';
    if (changes[errorsProp]) {
      this.errorsChanged.emit(this.errors);
    }

    const dateProp = 'date';
    if (!changes || !changes[dateProp]) { return; }

    const v = changes[dateProp].currentValue as string; // YYYY-MM-DDxxxx..
    if (v === undefined) { return; }

    this.value = v;
    this.SelectedDate = `${pad('0000', this.SelectedYear)}-${pad('00', this.SelectedMonth)}-${pad('00', this.SelectedDay)}`; // YYYY-MM-DD
  }

  set value(v: string) {
    if (!v) { return; }
    const m = parse(v, 'yyyy-MM-dd', new Date());
    if (!isValid(m)) { return; }

    const p = this.selectedDate();
    if (isValid(p) && isSameDay(m, p)) { return; }

    this.SelectedYear = getYear(m);
    this.SelectedMonth = getMonth(m) + 1; // date-fns months are 0 indexed
    this.SelectedDay = getDate(m);
    this.setDate(false);

  }
  get value(): string {
    const d = this.selectedDate();
    if (isValid(d)) {
    const dateString =  `${pad('0000', this.SelectedYear)}-${pad('00', this.SelectedMonth)}-${pad('00', this.SelectedDay)}`; // YYYY-MM-DD
    this.SelectedDate = dateString;
    return dateString;
   } else {
      return undefined;
    }
  }

  @ViewChild('monthDropDown', { static: true }) monthDropDown;
  @ViewChild('yearDropDown', { static: true }) yearDropDown;
  @ViewChild('dayDropDown', { static: true }) dayDropDown;

  SelectedYear: number;
  SelectedMonth: number;
  SelectedDay: number; 
  Years: number[] = [];
  Months: { id: number, name: string }[] = [];
  Days: number[] = [];
  
  valid: boolean;
  selectedDate(): Date {
    // parse as a string because if you feed date-fns Feb 31 it comes out March.
    const dateString = `${pad('0000', this.SelectedYear)}-${pad('00', this.SelectedMonth)}-${pad('00', this.SelectedDay)}`; // YYYY-MM-DD
        console.log(dateString)

    return parse(dateString, 'yyyy-MM-dd', new Date());
  }



  useBirthYearRange = false;

 

  initRanges() {
    if (this.useBirthYearRange) {
      const oldestYear = 1899;
      const youngestAge = 18;
      for (let y = oldestYear; y <= (new Date()).getUTCFullYear() - youngestAge; y++) {
        this.Years.push(y);
      }
    } else {
      for (let y = 2017; y <= (new Date()).getUTCFullYear(); y++) {
        this.Years.push(y);
      }
    }

    let n = 1;
    this.Months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map(m => ({ id: n++, name: m }));

    for (let d = 1; d <= 31; d++) {
      this.Days.push(d);
    }
  }

  setYear(year: number) {
    this.SelectedYear = year;
    this.setDate();
  }
  setMonth(month: number) {
    this.SelectedMonth = month;
    this.setDate();
  }
  setDay(day: number) {
    this.SelectedDay = day;
    this.setDate();
  }

  setDate(raiseEvent = true) {
    const m = this.selectedDate();
    if (!isValid(m)) {
      this.valid = false;
      return;
    }

    this.valid = true;
    if (raiseEvent) {
      this.onChangeCallback(this.value);
    }
  }

  writeValue(v: string) {
    if (v !== this.value) {
      this.value = v;
    }
  }

  registerOnChange(fn) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }

  onTouchedCallback = noop;
  onChangeCallback = noop;

}

function pad(pad: string, num: number): string {
  if (num === undefined) {
    return pad;
  } else {
    return (pad + num.toString()).slice(-pad.length);
  }
}
